import React, { useContext } from 'react';
import Collapsible from 'react-collapsible';
import { V2ModeContext } from '../requests/v2/V2ModeContext';

const CustomCollapsible = props => {
  const isV2 = useContext(V2ModeContext);

  // In V2 the outer accordion header already provides the section label.
  // Render children directly — no trigger bar, no animation wrapper, no
  // Bootstrap .container div that would add unwanted max-width / padding.
  if (isV2) {
    return <>{props.children}</>;
  }

  return (
    <Collapsible
      classParentString="collapsible"
      triggerTagName="div"
      containerElementProps={{ 'data-testid': props.testId }}
      parent
      {...props}
      // Bootstrap `.container` caps width (~720–960px) and centres itself —
      // on Orders cards that makes the Quotes bar a narrow strip. Callers
      // that need full-bleed width pass `noContainer`.
      trigger={
        props.noContainer ? (
          props.trigger
        ) : (
          <div className="container">{props.trigger}</div>
        )
      }
    >
      <div className={props.noContainer ? '' : 'container'}>
        {props.children}
      </div>
    </Collapsible>
  );
};

export default CustomCollapsible;
